module.exports = __webpack_public_path__ + "img/warn.432cb037.jpg";